import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import { BrainLoader } from '../../../Components/Generics.styled';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
const MessageContainer = styled.div`
    padding: 10px;
    height: 100%;
    color: white;
    background-color: #ff8560;
    border-radius: 8px;
    position: relative;
`;

const ArrowContainer = styled.div`
    position: absolute;
    left: -20px;
    top: 0px;
    color: #ff8560;
`;

const CopyButtonContainer = styled.div`
    color: white;
    margin-left: 10px;
    margin-top: auto; /* This pushes the child div to the bottom */
    cursor: pointer;
`;

const ChatMessageContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
`;

const ContentSection = styled.div``;
const IconSection = styled.div`
    display: flex;
    justify-content: right;
`;

const CopyComponentContainer = styled.div`
    display: flex;
    position: relative;
    font-size: 12px;
`;

const CustomBotChatMessage = ({ message }) => {
    const arrayOfNoCopyMsg = [
        'Okay I can help you create a custom email! Give me some background info on what the email should be about!',
        'Okay no problem! let me think of something...',
        'Click to expand and learn more!',
        'Here is a quick video of how davie.ai works!',
        'Do you need help with anything else?',
        'Ask me any question about davie.ai!',
        "Hold on I'm thinking...",
        'What would you like help with?',
        "Okay, if You need anything i'll be here. Just ask a question or select an option below.",
        'What would you like help with? You can ask a general question or select an option below.',
    ];

    const dontShowCopy = arrayOfNoCopyMsg.includes(message);

    const CopiedComponent = () => {
        return (
            <CopyComponentContainer>
                <CheckIcon fontSize="small" /> Copied!
            </CopyComponentContainer>
        );
    };

    const spanRef = useRef(null);
    const [copyState, setCopyState] = useState(false);

    const copyToClipboard = () => {
        if (spanRef.current) {
            const textToCopy = spanRef.current.innerText;

            // Create a temporary textarea
            const tempTextarea = document.createElement('textarea');
            tempTextarea.value = textToCopy;

            // Append the textarea to the document
            document.body.appendChild(tempTextarea);

            // Select and copy the text from the textarea
            tempTextarea.select();
            document.execCommand('copy');

            // Remove the temporary textarea
            document.body.removeChild(tempTextarea);

            setCopyState(true);

            // Reset the icon after 5 seconds
            setTimeout(() => {
                setCopyState(false);
            }, 3000);
        }
    };

    return (
        <MessageContainer>
            <ArrowContainer>
                <ArrowLeftIcon fontSize="large" />
            </ArrowContainer>
            <ChatMessageContainer>
                <ContentSection>{!message ? <BrainLoader /> : <span ref={spanRef}>{message}</span>}</ContentSection>
                <IconSection>
                    {dontShowCopy ? null : (
                        <CopyButtonContainer onClick={() => copyToClipboard()}>
                            {copyState === false ? <ContentCopyIcon fontSize="small" /> : <CopiedComponent />}
                        </CopyButtonContainer>
                    )}
                </IconSection>
            </ChatMessageContainer>
        </MessageContainer>
    );
};

CustomBotChatMessage.propTypes = {
    message: propTypes.string,
};
export default CustomBotChatMessage;
